import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import classnames from 'classnames';

import PuppyCard from 'dpl/puppy_search_results/components/Card';
import { ANALYTICS_VIEW_FEATURE_LOCATIONS } from 'dpl/constants/analytics';

import SimilarBreedsSection from './SimilarBreedsSection';

// Drives both the slide width and the card's photo, so the square photo always
// fills the slide.
const CARD_WIDTH = 200;

const CARD_SMART_IMAGE_PROPS = {
  width: `${CARD_WIDTH}px`,
  height: `${CARD_WIDTH}px`
};

const SPLIDE_OPTIONS = {
  arrows: false,
  dragMinThreshold: 20,
  easing: 'cubic-bezier(0.5, 0, 0.5, 1)',
  flickMaxPages: 1,
  flickPower: 300,
  gap: 16,
  keyboard: 'focused',
  padding: 20,
  pagination: false,
  perPage: 1,
  speed: 350,
  snap: true,
  fixedWidth: CARD_WIDTH
};

interface SimilarBreedsPuppyCarouselProps {
  puppies: any[];
  view: string;
  footer?: React.ReactNode;
  className?: string | null;
}

/** Puppy-carousel arm: up to six puppies, each from a different breeder. */
export default function SimilarBreedsPuppyCarousel({
  puppies,
  view,
  footer = null,
  className = null
}: SimilarBreedsPuppyCarouselProps) {
  if (!puppies.length) {
    return null;
  }

  return (
    <SimilarBreedsSection
      className={classnames('overflow-hidden pv4', className)}
      footer={footer}
    >
      <Splide
        className="SimilarBreedsPuppyCarousel"
        options={{
          ...SPLIDE_OPTIONS,
          drag: puppies.length > 1
        }}
      >
        {puppies.map((puppy, idx) => (
          <SplideSlide key={puppy.id}>
            <PuppyCard
              className="pb3"
              puppy={puppy}
              breedName={puppy.breed?.name}
              smartImageProps={CARD_SMART_IMAGE_PROPS}
              analytics={{
                view,
                view_feature_location:
                  ANALYTICS_VIEW_FEATURE_LOCATIONS.SIMILAR_BREED_PUPPIES,
                position: idx + 1
              }}
              bordered
              compact
            />
          </SplideSlide>
        ))}
      </Splide>
    </SimilarBreedsSection>
  );
}
